import apiClient from "../../utils/apiClient"; // Adjust path based on your structure
const APIKEY = process.env.REACT_APP_INTERNAL_API_KEY

export const FetchCategory = () => {
  return apiClient.get('/products/categories/level-one', {
    headers: {
      'x-api-key': APIKEY
    }
  });
}


export const SubCategory = (parentCategoryId) => {
  return apiClient.get(`/products/categories/v1/${parentCategoryId}/children`, {
    headers: {
      'x-api-key': APIKEY
    }
  });
}


export const FetchBanner = () => {
  return apiClient.get('/products/banners/active', {
    headers: {
      'x-api-key': APIKEY,
    }
  });
}
